import React from 'react';
import './CRV.css';
import Footer from '../Footer'
import { useEffect } from 'react';

function TopContribuorsV () {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);


    return (
        <div>

            <section>
            <div className="holds-the-iframe">
            <iframe className='frame' src="https://script.google.com/macros/s/AKfycbzK5grhs9Ox7P3I9BltDZ73f2ORVQQcXqph1HPqKu0WV4awZYueZj-7lJh2PNm9BpAB/exec" width={'100%'} height="500px"></iframe>
                {/* <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossorigin="anonymous"></script> */}
            </div>
            <div class='air air1'></div>
            <div class='air air2'></div>
            <div class='air air3'></div>
            <div class='air air4'></div>
            </section>

            <Footer/>
        </div>
    );
}

export default TopContribuorsV;
